import useAccountSettingsStore from "../../features/settings/store/useAccountSettingsStore";
import useCampaignAnalysisStore from "../../features/campaigns/store/useCampaignAnalysisStore";
import use123zapStore from "../../stores/123zapStore";

let accountScopedStoresResetVersion = 0;

export function getAccountScopedStoresResetVersion() {
  return accountScopedStoresResetVersion;
}

export function resetAccountScopedStores() {
  accountScopedStoresResetVersion += 1;
  use123zapStore.getState().resetSessionState();
  useAccountSettingsStore.getState().resetAccountSettingsState();
  useCampaignAnalysisStore.getState().resetCampaignAnalysisState();
}
